import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GetPostalPoint from './GetPostalPoint.graphql';

export const useGetPostalPoint = (options) =>
  useCustomQuery(GetPostalPoint, {
    url: config('GRAPHQL_API_URL'),
    accessor: 'getPostalPoint',
    ...options,
  });
